import { Card, Row, Form, Col, Select, Modal, Button } from 'antd';
import React, { useState } from 'react';
import StockInForm from './stock-in-form';
import SpsaWOStockIn from './spsa-wo-stockin';
import LotInfoView from '../../../../../warehouse-management/warehouse-components/stock-grid/src/lib/lot-info-view';

const SpsaStockInMain = () => {

  const [mainForm] = Form.useForm();

  const { Option } = Select;

  const [stockInType, setStockInType] = React.useState(null);
      const [isLotInfoModalVisible, setIsLotInfoModalVisible] = useState<boolean>(false);

  const onStockInTypeChange = (val) => {

    mainForm.setFieldsValue({
      stockInType: val
    });

    setStockInType(val);
  };

  return (
    <div>

      <Card title={<span style={{ color: 'white' }}> Stock In</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
                extra={<span style={{ color: 'white' }} ><Button type="default" onClick={() => setIsLotInfoModalVisible(true)}>Lot Info </Button> </span>}

        >
          
        <Form form={mainForm} layout='vertical'>

          <Row gutter={16}>

            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 8 }}
              lg={{ span: 6 }}
              xl={{ span: 4 }}
            >

              <Form.Item
                name="stockInType"
                label="Stock In Type"
                rules={[
                  {
                    required: true,
                    message: 'Missing Stock In Type',
                  },
                ]}
              >

                <Select
                  showSearch
                  optionFilterProp="children"
                  placeholder="Select Stock In Type"
                  allowClear
                  onChange={onStockInTypeChange}
                >

                  <Option value="workOrder">
                    Export
                  </Option>

                  <Option value="lotNumber">
                    Production
                  </Option>

                </Select>

              </Form.Item>

            </Col>

          </Row>

        </Form>

      </Card>

      {
        stockInType === 'workOrder' &&
        <SpsaWOStockIn />
      }

      {
        stockInType === 'lotNumber' &&
        <StockInForm />
      }
    <Modal
        
        visible={isLotInfoModalVisible}
        onCancel={() => setIsLotInfoModalVisible(false)}
        footer={null}
        width={'80%'}
        destroyOnClose
      >
        <LotInfoView />
      </Modal>
    </div>
  );
};

export default SpsaStockInMain;